import CacheCore from "@/cache/core.cache";

export default new class AuthRoleCache extends CacheCore {
  constructor() {
    super('auth-role');
  }
}();
